export const translations = {
  tr: {
    nav: {
      home: "Ana Sayfa",
      scenarios: "Senaryolar",
      builder: "Proje Oluştur",
      contact: "Destek Al",
      cta: "Destek Al",
    },
    hero: {
      badge: "KENDİN YAP — BİZ YANINDAYIZ",
      title1: "Akıllı evini",
      title2: "kendi ellerinle kur.",
      subtitle:
        "Hayalindeki otomasyonu sen tasarla — donanım, kablo şeması, kurulum rehberi ve canlı destek bizden. Garaj kapısından bahçe sulamasına; eli ilk kez aletle tanışana bile yetecek netlikte.",
      ctaPrimary: "Senaryoları İncele",
      ctaSecondary: "Proje Oluştur",
      stats: [
        { k: "10+", v: "Hazır Senaryo" },
        { k: "15+", v: "Cihaz Türü" },
        { k: "7/24", v: "Teknik Destek" },
      ],
    },
    featured: {
      label: "ÖNE ÇIKAN PROJELER",
      title: "En çok yapılan üç DIY senaryo.",
      subtitle:
        "Komşunun bahçesini kurutmadan tatile çıkmak, arabadan inmeden garajı açmak, evi gözünden ayırmamak — üç klasik, üç tek-hafta-sonu projesi.",
    },
    sceneList: {
      label: "TÜM SENARYOLAR",
      title: "Her hafta sonu için bir proje.",
      subtitle:
        "Adım adım kurulabilen 10 farklı kullanım örneği. Birini seç, ekipman listeni al, kurulum videolarını izle. Takıldığında bir mesaj uzaktayız.",
    },
    cta: {
      label: "PROJE OLUŞTUR",
      title: "Senaryoları seç, malzeme listen ve rehberin hazır.",
      subtitle:
        "İstediğiniz senaryoları işaretleyin; sistem gerekli cihazların listesini, kurulum sırasını ve takıldığınız yerde başvurmanız gereken adımları otomatik olarak çıkarır. Donanımı edinin, takıldığında bize yazın.",
      btn: "Projemi Tasarla",
    },
    contact: {
      label: "DESTEK",
      title: "Takıldığın yerde elimizden tutuyoruz.",
      subtitle:
        "İster kurulum öncesi danışmanlık, ister kablo bağlantısında çakılma — projenizi anlatın, telefon, e-posta veya video görüşmesiyle yanınızda olalım.",
      name: "Adınız",
      email: "E-posta",
      phone: "Telefon (opsiyonel)",
      message: "Projeniz / sorunuz hakkında kısa açıklama",
      submit: "Destek Talebi Gönder",
      success: "Teşekkürler! Talebiniz alındı, en kısa sürede dönüyoruz.",
      error: "Bir sorun oluştu, lütfen tekrar deneyin.",
    },
    scenario: {
      trigger: "Tetikleyici",
      action: "Aksiyon",
      flow: "Kurulum Akışı",
      products: "Gerekli Donanım",
      addToBuilder: "Proje Listeme Ekle",
      added: "Listeye Eklendi",
      back: "Tüm Senaryolar",
      explore: "Projeyi Aç",
      difficulty: "Zorluk",
      duration: "Süre",
    },
    builder: {
      title: "Proje Oluşturucu",
      subtitle:
        "Senaryoları seç, donanım listen otomatik çıksın. Listeyi gönder; sana adım adım kurulum rehberini ve canlı teknik desteği biz açalım.",
      stepScenarios: "1. Yapmak istediğin senaryoları seç",
      stepList: "2. Otomatik oluşturulan donanım listen",
      stepForm: "3. Destek için iletişim bilgilerin",
      empty: "Henüz senaryo seçmediniz. Yukarıdan bir veya birkaç senaryo seçin.",
      scenariosSelected: "proje seçildi",
      productsNeeded: "donanım türü gerekiyor",
      clear: "Listeyi Temizle",
      sendQuote: "Destek + Donanım Listesi İste",
    },
    footer: {
      tagline: "Akıllı ev DIY projeleri — donanım ve teknik destek bizden.",
      rights: "Tüm hakları saklıdır.",
    },
    process: {
      label: "NASIL ÇALIŞIR",
      title: "Dört adımda akıllı evin kurulur.",
      items: [
        { t: "Senaryo Seç", d: "İhtiyaca uygun senaryoyu seçersin — sulama, güvenlik, garaj... ya da hepsi." },
        { t: "Listeni Al", d: "Sistem gerekli donanımı, kablo şemasını ve kurulum sırasını otomatik üretir." },
        { t: "Donanımı Edin", d: "Listeyi bize gönder ya da kendin tedarik et. Marka serbest, biz öneriyoruz." },
        { t: "Birlikte Kur", d: "Video rehberler, kablo şemaları, WhatsApp ve telefon desteği — takıldığın anda buradayız." },
      ],
    },
    inspiration: {
      label: "GERÇEK PROJELER",
      title: "Müşterilerimizin kurduğu mini-projeler.",
      subtitle: "Hafta sonu projeleri, balkondan başlayıp tüm eve yayılan kurulumlar.",
    },
  },
  en: {
    nav: {
      home: "Home",
      scenarios: "Scenarios",
      builder: "Build Project",
      contact: "Get Support",
      cta: "Get Support",
    },
    hero: {
      badge: "DIY SMART HOME — WITH BACKUP",
      title1: "Build your smart home,",
      title2: "with our hands behind you.",
      subtitle:
        "You design the routine — we ship the hardware, the wiring diagram, the setup guide and live support. From garage doors to garden irrigation; clear enough for first-time builders.",
      ctaPrimary: "Browse Scenarios",
      ctaSecondary: "Build Project",
      stats: [
        { k: "10+", v: "Ready Scenes" },
        { k: "15+", v: "Device Types" },
        { k: "24/7", v: "Tech Support" },
      ],
    },
    featured: {
      label: "FEATURED PROJECTS",
      title: "Three DIY routines our community loves.",
      subtitle:
        "Travel without the garden dying, open the garage without leaving the car, keep an eye on the house at all times — three classics, three weekend builds.",
    },
    sceneList: {
      label: "ALL SCENARIOS",
      title: "A weekend project for every home.",
      subtitle:
        "10 step-by-step use cases. Pick one, pull your part list, watch the install videos. Stuck? Ping us.",
    },
    cta: {
      label: "BUILD A PROJECT",
      title: "Pick scenarios, get your parts list and guide.",
      subtitle:
        "Tick the routines you want; we generate the device list, install order, and the exact spots to ask for help. Source the gear, ping us when you're stuck.",
      btn: "Design My Project",
    },
    contact: {
      label: "SUPPORT",
      title: "We hold the wire when you fumble.",
      subtitle:
        "From pre-install consulting to that 'this red cable doesn't fit' moment — describe your project; we'll reply by phone, email or video call.",
      name: "Your name",
      email: "Email",
      phone: "Phone (optional)",
      message: "Briefly describe your project or question",
      submit: "Request support",
      success: "Thanks! We received your request and will reply shortly.",
      error: "Something went wrong, please try again.",
    },
    scenario: {
      trigger: "Trigger",
      action: "Action",
      flow: "Build steps",
      products: "Hardware list",
      addToBuilder: "Add to my project",
      added: "Added to list",
      back: "All scenarios",
      explore: "Open project",
      difficulty: "Difficulty",
      duration: "Duration",
    },
    builder: {
      title: "Project Builder",
      subtitle:
        "Pick scenarios, hardware list auto-generates. Send the list — we open the step-by-step guide and live tech support for you.",
      stepScenarios: "1. Pick the scenarios you want to build",
      stepList: "2. Your auto-generated hardware list",
      stepForm: "3. Drop your contact for support",
      empty: "No scenarios selected yet. Pick one above to begin.",
      scenariosSelected: "projects selected",
      productsNeeded: "device types needed",
      clear: "Clear list",
      sendQuote: "Request support + hardware",
    },
    footer: {
      tagline: "DIY smart home projects — hardware & tech support from us.",
      rights: "All rights reserved.",
    },
    process: {
      label: "HOW IT WORKS",
      title: "Your smart home in four steps.",
      items: [
        { t: "Pick a scenario", d: "Select what you want — irrigation, security, garage... or all of them." },
        { t: "Get your list", d: "We generate the hardware list, wiring sketch and install order automatically." },
        { t: "Source the gear", d: "Order from us or anywhere — your call. We recommend trusted brands." },
        { t: "Build with us", d: "Video guides, wiring diagrams, WhatsApp + phone help — we're one ping away." },
      ],
    },
    inspiration: {
      label: "REAL BUILDS",
      title: "Mini projects our customers shipped.",
      subtitle: "Weekend builds — from a single balcony sensor to a full-house setup.",
    },
  },
};
